module.exports = __webpack_public_path__ + "img/relief_1.7cd26968.jpg";